import React from 'react';

const ManageService = () => <h1 className="pageTitle">Service</h1>;

export default ManageService;
